import { investmentEntityRequest } from '@utils/request';
import { TaxData } from 'types/tax';

export const getTaxData = async (): Promise<TaxData> => {
	const response = await investmentEntityRequest.get(`/account/tax-info`);
	return response.data;
};